<div class="cursor-pointer" (click)="onClick()">
  <div
    class="flex flex-column justify-content-center bg p-4 shadow-2 border-round-md"
  >
    <div class="flex flex-column py-2">
      <span class="font-bold font-size text-left">{{ title }}</span>
    </div>
  </div>
</div>
